import { createContext, useContext, useReducer } from "react";
import { useApi } from "../hooks/useApi";

const AuthContext = createContext();

const initialState = {
  user: {},
  isAuthenticated: false,
};

function reducer(state, action) {
  switch (action.type) {
    case "login":
      return { ...state, user: action.payload, isAuthenticated: true };
    case "logout":
      return { ...state, user: {}, isAuthenticated: false };
    case "restoreauth":
      return { ...state, user: action.payload, isAuthenticated: true };
    default:
      throw new Error("Unknown action");
  }
}

function AuthProvider({ children }) {
  const [{ user, isAuthenticated }, dispatch] = useReducer(
    reducer,
    initialState
  );
  const { fetchData } = useApi();

  // ログイン
  const adminLogin = async (requestBody) => {
    const userData = await fetchData(
      "/api/auth/admin/login/",
      "POST",
      requestBody
    );
    if (userData) {
      dispatch({ type: "login", payload: userData });
      // localStorageに格納
      localStorage.setItem("userData", JSON.stringify(userData));
      return true;
    }
    return false;
  };

  // ログアウト
  const adminLogout = async () => {
    await fetchData("/api/auth/admin/logout/", "GET");

    dispatch({ type: "logout" });
    // localStorageから削除
    localStorage.removeItem("userData");
  };

  // ログイン
  const mypageLogin = async (requestBody) => {
    const userData = await fetchData(
      "/api/auth/mypage/login/",
      "POST",
      requestBody
    );
    if (userData) {
      dispatch({ type: "login", payload: userData });
      // sessionStrageに格納
      localStorage.setItem("userData", JSON.stringify(userData));
      return true;
    }
    return false;
  };

  // ログアウト
  const mypageLogout = async () => {
    await fetchData("/api/auth/mypage/logout/", "GET");

    dispatch({ type: "logout" });
    // localStorageから削除
    localStorage.removeItem("userData");
  };

  // localStorageからユーザー情報取得
  const restoreAuth = () => {
    if (isAuthenticated) {
      return true;
    }
    // localStorageからuserData取得
    const getUserData = localStorage.getItem("userData");
    if (getUserData != null) {
      dispatch({ type: "restoreauth", payload: JSON.parse(getUserData) });
      return true;
    }
    return false;
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        isAuthenticated,
        adminLogin,
        adminLogout,
        mypageLogin,
        mypageLogout,
        restoreAuth,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined)
    throw new Error("AuthContext was used outside AuthProvider");
  return context;
};

export { AuthProvider, useAuth };
